import React, { useEffect, useRef } from 'react';
import { Container, Typography, List, ListItem, ListItemAvatar, Avatar, ListItemText, Button, Box, Grid2, ListItemIcon, useTheme } from '@mui/material';
import WebBanner from '../../layouts/WebLayout/components/WebBanner/WebBanner';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import Term from '../../assets/images/terms.svg';
import { useDispatch, useSelector } from 'react-redux';
import { reset } from '../../layouts/WebLayout/SkipToMainContent/SkipToMainContentSlice';

const HyperLinkingPolicy = () => {
  const theme = useTheme();
  const dynamicTextColor = theme.palette.mode === "light" ? "#333333" : "#fff";
  const skipClicked=useSelector((state:any)=>
    {
       return state?.skip?.SkipButtonClicked
   });
const dispatch=useDispatch();
const sectionRef = useRef<HTMLElement | null>(null);
const handleScroll = () => {
   if (sectionRef.current) {
     sectionRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
     dispatch(reset());
   }
 }
 useEffect(()=>{
   if(skipClicked){
   handleScroll() 
   } 
 },[skipClicked])

  const numberStyles = {
    backgroundColor: '#fff',
    color: '#1976d2',
    border: '2px solid #1976d2',
    fontWeight: 'bold',
  };
  return (
    <>
      <WebBanner
        title="Hyperlinking Policy"
        subtitle=" "
        image={Term}
      />
      <Container maxWidth="xl">
        <Box sx={{padding:{ xs:"2rem 0",sm:"1rem 0"}}}>
          <Grid2 container sx={{
            justifyContent: "center"
          }}  ref={sectionRef as any}>
            <Grid2 size={12}  sx={{margin:{ xs:"2rem 0",sm:"3rem 0"}}}>
              <Typography variant="body1" sx={{fontSize:{xs:`calc(1em * var(--dynamic-font-size, 1))`,sm:`calc(1.25em * var(--dynamic-font-size, 1))`}, lineHeight: "40px", color: dynamicTextColor}}>
               At many places in this Website, you shall find links to other websites/portals. NHAI is not responsible for the contents and reliability of the linked websites and does not necessarily endorse the views expressed in them. Mere presence of the link or its listing on this website should not be assumed as endorsement of any kind. We cannot guarantee that these links will work all the time and we have no control over availability of linked pages.
              </Typography>
            </Grid2>
          </Grid2>
        </Box>
      </Container>
    </>
  );
};

export default HyperLinkingPolicy;
